export default __webpack_public_path__ + "static/media/logo-without-text.b6f922bb.png";